import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

export default function ELearningCredits({ customCredits = false }) {
  const [eLearningAllowance, setELearningAllowance] = useState({
    loaded: false,
    currentCredits: null,
    hasError: false,
  });

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.billing.ELearningCreditsSection',
  });

  const fetchELearningAllowance = () => {
    axios
      .get('/e_learning/allowance', {
        params: { custom_credits: customCredits },
      })
      .then((response) =>
        setELearningAllowance({
          ...eLearningAllowance,
          currentCredits: response.data.data.attributes.currentCredits,
          loaded: true,
        }),
      )
      .catch((_error) =>
        setELearningAllowance({ ...eLearningAllowance, hasError: true }),
      );
  };

  useEffect(() => {
    fetchELearningAllowance();
  }, []);

  return (
    <div className='tw-h-5'>
      <p>
        {eLearningAllowance.loaded ?
          i18nT('remainingCredits', {
            count: eLearningAllowance.currentCredits,
          })
        : eLearningAllowance.hasError && i18nT('error')}
      </p>
    </div>
  );
}
